import {HandlerList} from "../../../infrastructure/handlers/handler-list";
import {TimingHandler} from "../../../infrastructure/handlers/timing-handler";
import {StandingsWidgetFetchHandler} from "./standings-widget.fetch-handler";
import {StandingsWidgetPopulateDataHandler} from "./standings-widget.populate-data-handler";
import {StandingsWidgetTypeChangeHandler} from "./standings-widget.type-change.handler";
import {StandingsWidgetToggleGroupHandler} from "./standings-widget.toggle-group-handler";
import {StandingsWidgetChangeHighLightedRowsHandler} from "./standings-widget.change-highlighted-rows.handler";
import {EntityClickEventHandler} from "../../../core/handlers/entity-click-event.handler";
import {MatchDetailsClickEventHandler} from "../../../core/handlers/match-details.click-event.handler";
import {StandingsClickEventHandler} from "../../../core/handlers/standings-click-event.handler";
import {PopulateSponsorshipBookmakerHandler} from "../../../core/handlers/populate-sponsorship-bookmaker.handler";
import {WidgetLoadedEventHandler} from "../../../core/handlers/widget-loaded-event.handler";
import {StandingsWidgetDisplayEventHandler} from "./standings-widget.display-event.handler";
import {PoweredByChangeTitleHandler} from "../../../core/handlers/powered-by.change-title.handler";
import {BracketsStageClickEventHandler} from "../../../core/handlers/brackets.stage-click-event.handler";
import {StandingsWidgetStageChangeHandler} from "./standings-widget.stage-change.handler";
import {StandingsWidgetCompetitionChangeHandler} from "./standings-widget.competition-change.handler";
import {SeeAllButtonClickAnalyticsEventHandler} from "../../../core/handlers/see-all-button-click.analytics-event.handler";
import {StandingsWidgetChangeSeasonKeyHandler} from "./standings-widget.change-season-key.handler";

export class StandingsWidgetHandlers extends HandlerList {

  static injectables = [
    StandingsWidgetFetchHandler,
    StandingsWidgetPopulateDataHandler,
    StandingsWidgetTypeChangeHandler,
    StandingsWidgetToggleGroupHandler,
    StandingsWidgetChangeHighLightedRowsHandler,
    StandingsWidgetDisplayEventHandler,
    StandingsWidgetStageChangeHandler,
    MatchDetailsClickEventHandler,
    StandingsClickEventHandler,
    StandingsWidgetCompetitionChangeHandler,
    StandingsWidgetChangeSeasonKeyHandler,
    EntityClickEventHandler,
    WidgetLoadedEventHandler,
    BracketsStageClickEventHandler,
    SeeAllButtonClickAnalyticsEventHandler,
    PopulateSponsorshipBookmakerHandler,
    PoweredByChangeTitleHandler,
    TimingHandler
  ];

  constructor(
    standingsWidgetFetchHandler: StandingsWidgetFetchHandler,
    standingsWidgetPopulateDataHandler: StandingsWidgetPopulateDataHandler,
    standingsWidgetChangeTypeHandler: StandingsWidgetTypeChangeHandler,
    standingsWidgetToggleGroupHandler: StandingsWidgetToggleGroupHandler,
    standingsWidgetChangeHighLightedRowsHandler: StandingsWidgetChangeHighLightedRowsHandler,
    standingsWidgetDisplayEventHandler: StandingsWidgetDisplayEventHandler,
    standingsWidgetChangeStageHandler: StandingsWidgetStageChangeHandler,
    matchDetailsClickEventHandler: MatchDetailsClickEventHandler,
    standingsClickEventHandler: StandingsClickEventHandler,
    standingsWidgetCompetitionChangeHandler: StandingsWidgetCompetitionChangeHandler,
    standingsWidgetChangeSeasonKeyHandler: StandingsWidgetChangeSeasonKeyHandler,
    entityClickEventHandler: EntityClickEventHandler,
    widgetLoadedEventHandler: WidgetLoadedEventHandler,
    bracketsStageClickEventHandler: BracketsStageClickEventHandler,
    seeAllButtonClickAnalyticsEventHandler: SeeAllButtonClickAnalyticsEventHandler,
    populateSponsorshipBookmakerHandler: PopulateSponsorshipBookmakerHandler,
    poweredByChangeTitleHandler: PoweredByChangeTitleHandler,
    timingHandler: TimingHandler
  ) {
    super();

    [
      standingsWidgetFetchHandler,
      standingsWidgetPopulateDataHandler,
      standingsWidgetChangeTypeHandler,
      standingsWidgetToggleGroupHandler,
      standingsWidgetChangeHighLightedRowsHandler,
      standingsWidgetDisplayEventHandler,
      standingsWidgetChangeStageHandler,
      matchDetailsClickEventHandler,
      standingsClickEventHandler,
      standingsWidgetCompetitionChangeHandler,
      standingsWidgetChangeSeasonKeyHandler,
      entityClickEventHandler,
      widgetLoadedEventHandler,
      bracketsStageClickEventHandler,
      seeAllButtonClickAnalyticsEventHandler,
      populateSponsorshipBookmakerHandler,
      poweredByChangeTitleHandler,
      timingHandler
    ].forEach(handler => this.add(handler));
  }
}
